var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dl',{class:{
	'im-section': true,
	'msg-list-container': true,
	'disabled': !_vm.conversationList.length,
	'nodata': !((_vm.conversationList.find(function (o) { return o.id == _vm.currentSessionId; }) || {}).data || []).length,
	'load-msg': _vm.$store.state.msgLoadStatus
}},[_c('dt',{staticClass:"head"},[(!_vm.currentSessionId)?[_vm._v("--没有会话--")]:[_vm._v(_vm._s((_vm.conversationList.find(function (o) { return o.id == _vm.currentSessionId; }) || {}).clientNickName || '[未知用户]'))]],2),_vm._v(" "),_c('dd',[_c('msgList'),_vm._v(" "),_c('aiAnswer',{on:{"sendMsg":_vm.sendAiAnswerMsg}}),_vm._v(" "),_c('sendMsg',{ref:"sendMsg",on:{"closeSession":_vm.closeSession}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47da916c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/msgList/msgListContainer.vue
// module id = null
// module chunks = 